export default "__VITE_ASSET__ec861e30__"